import { Link } from 'react-router-dom';

export default function AiExploreBar({ active = 'videos' }) {
  const items = [
    { key: 'videos', label: 'Videos', to: '/light/page-ai-videos' },
    { key: 'model', label: 'Model Shoot', to: '/light/page-ai-model-shoot' },
    { key: 'product', label: 'Product Shoot', to: '/light/page-ai-product-shoot' },
  ];

  return (
    <div className="ai-explore-bar">
      {items.map((it) => (
        <Link
          key={it.key}
          to={it.to}
          className={`ai-explore-tab ${active === it.key ? 'is-active' : ''}`.trim()}
        >
          {it.label}
        </Link>
      ))}
    </div>
  );
}

